import _ from 'lodash';
import { IAutorunOptions, IReactionPublic, autorun } from 'mobx';
import { DependencyList, useEffect, useRef } from 'react';

const useAutorun = (
  view: (r: IReactionPublic) => void,
  opts?: IAutorunOptions,
  deps?: DependencyList
) => {
  const oldOpts = useRef(opts);
  const oldDeps = useRef(deps);
  useEffect(() => {
    oldOpts.current = opts;
    oldDeps.current = deps;
    return autorun(view, opts);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_.isEqual(oldOpts.current, opts), _.isEqual(oldDeps, deps)]);
};

export default useAutorun;
